import { useSearchParams } from "react-router";

import type { FilterElementInput } from "app/contexts/__generated__/AnalyticsContextQuery.graphql";

/**
 * useSearch - parse search params, and translate search terms
 * and text filter expressions to FilterElementInput operands
 * @returns FilterElementInput
 */
export function useSearch(): FilterElementInput[] {
  const [searchParams] = useSearchParams();
  const search = searchParams.get("search");

  return createSearchFilter(search);
}

function isFilter(word: string) {
  return word.includes(":");
}

function translateFilter(word: string) {
  const operands = [];

  if (word) {
    if (isFilter(word)) {
      const [name, value] = word.split(":");
      if (name === "tag") {
        operands.push({ single: { name: word, operator: "exists" } });
      } else {
        operands.push({ single: { name, value } });
      }
    } else {
      operands.push({ single: { name: "name", value: word } });
    }
  }
  return operands;
}

export function createSearchFilter(search: string | null) {
  const words = search?.split(" ");

  return (words ?? []).flatMap((word) => translateFilter(word));
}
